import React, { useEffect, useState } from "react";
import Input from "../../form/Input";
import Button from "../../form/Button";
import Image from "../../elements/Image";
import Background from "../../../assets/image/background.jpg";
import Screenshot from "../../../assets/image/demo-screenshot.png";
import { postData } from "../../../services/api";
import toastr from "toastr";
import { Link } from "react-router-dom";
import SchedualeDemoPopup from "../../popup/SchedualeDemoPopup";
import { MAIN_LOGO } from "../../../constant/Constant";

const FreeTrialContent = ({ type, segment }) => {
  const [loading, setLoading] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pageData, setPageData] = useState({});
  const [scheduleDemoPopup, setScheduleDemoPopup] = useState(false);

  const handelSubmit = async () => {
    setLoading(true);
    try {
      const result = await postData("/enquery/create", {
        type: 3,
        full_name: fullName,
        email: email,
        phone: phone,
        leadPath: segment,
      });
      if (result.status === 200) {
        setLoading(false);
        setEmail("");
        setPhone("");
        setFullName("");
        toastr.success(result.message);
      } else {
        setLoading(false);
        toastr.error(result.message);
      }
    } catch (e) {
      setLoading(false);
      toastr.error(e.message);
    }
  };

  useEffect(() => {
    const loadPageDetails = async () => {
      try {
        const result = await postData("/lead-content/details", {
          slug: "intro",
        });
        if (result.data) {
          setPageData(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPageDetails();
  }, []);

  return (
    <>
      <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
        <div className="mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto">
          <Link to={"/"}>
            <div className="h-14 w-full flex justify-center object-contain mb-5">
              <Image
                src={MAIN_LOGO}
                alt={""}
                width={"100%"}
                height={"100%"}
                classes={"object-contain object-center"}
              />
            </div>
          </Link>
        </div>

        <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
          <Image
            src={Background}
            alt={""}
            width={"100%"}
            height={"100%"}
            effect={"blur"}
            classes={"flex object-cover"}
          />
        </div>
        <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          {/* <h2 className="mb-6 block xl:text-6xl text-4xl font-bold text-dark-teal-400 tracking-tight">
            {(pageData?.description)?pageData?.description:''}
          </h2> */}
          <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
            <div className="w-full lg:w-1/2 xl:w-5/12">
              <div className="relative w-full max-w-md lg:max-w-none mx-auto space-y-10">
                <div className="space-y-4">
                  <h2 className="xl:text-5xl text-3xl font-bold text-dark-teal-400 tracking-tight">
                    {type && type === 1 ? "Watch the Demo" : "View Demo"}
                  </h2>
                  <h4 className="text-lg text-black leading-tight">
                    See why SuccessionNow is the #1 rated succession planning
                    software on the market
                  </h4>
                </div>
                <div className="relative space-y-5">
                  <div className="relative">
                    <Input
                      labelClasses={"!text-white font-light"}
                      inputType={"text"}
                      inputClasses={
                        "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                      }
                      inputPlaceholder={"Full Name"}
                      inputValue={fullName}
                      inputName={""}
                      errorType={""}
                      isDisabled={false}
                      setInput={setFullName}
                    />
                  </div>
                  <div className="relative">
                    <Input
                      labelClasses={"!text-white font-light"}
                      inputType={"email"}
                      inputClasses={
                        "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                      }
                      inputPlaceholder={"Work Email"}
                      inputValue={email}
                      inputName={""}
                      errorType={""}
                      setInput={setEmail}
                    />
                  </div>
                  {/* <div className="relative">
                    <Input
                      labelClasses={"!text-white font-light"}
                      inputType={"text"}
                      inputClasses={
                        "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                      }
                      inputPlaceholder={"Phone Number"}
                      inputValue={phone}
                      inputName={""}
                      errorType={""}
                      setInput={setPhone}
                    />
                  </div> */}
                  <div className="relative md:col-span-2">
                    <div className="flex justify-center mt-8">
                      <Button
                        buttonClasses="!bg-dark-teal-700 hover:!bg-dark-teal-900 !px-6 !w-full !h-14 !text-xl rounded-lg"
                        buttonLabelClasses="!text-xl"
                        buttonType={"button"}
                        buttonLabel={
                          type && type === 1 ? "Submit" : "View Demo"
                        }
                        buttonIcon={
                          loading ? "fa-light fa-spinner fa-spin" : ""
                        }
                        buttonIconPosition={"left"}
                        functions={handelSubmit}
                        buttonHasLink={false}
                        buttonDisabled={loading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2 xl:w-5/12">
              <div className="relative space-y-10">
                <ul className="pl-8 space-y-5">
                  {pageData?.content &&
                    pageData?.content.length > 0 &&
                    pageData?.content.map((item, index) => (
                      <li
                        key={index}
                        className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8"
                      >
                        <span className="flex leading-tight text-sm xl:text-base">
                          {item?.title}
                        </span>
                        <span className="flex justify-end text-xs text-slate-400 font-normal mt-1">
                          {item?.creator ? "- " + item?.creator : ""}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="h-40 sm:h-72 md:h-96 lg:h-[440px] flex">
          <div className="absolute w-full max-w-[1024px] px-6 xl:px-0 bottom-0 left-1/2 -translate-x-1/2 flex">
            <div className="absolute z-[1] w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-solid fa-play"}
                buttonIconPosition={"left"}
                buttonClasses={
                  "!w-16 !h-16 !p-0 !rounded-full !text-3xl !mt-16 hover:!bg-teal-600 !shadow-lg"
                }
                functions={() => {
                  setScheduleDemoPopup(true);
                }}
              />
            </div>
            <Image
              src={Screenshot}
              alt={""}
              width={"100%"}
              height={"100%"}
              effect={"blur"}
              classes={"flex object-cover"}
            />
          </div>
        </div>
      </section>
      {scheduleDemoPopup && (
        <SchedualeDemoPopup
          isOpen={scheduleDemoPopup}
          setIsOpen={(val) => setScheduleDemoPopup(val)}
          data={type}
          leadPath={segment}
          getActionValue={(obj) => {
            // setActionValue(obj);
            // setIsUpdate(true);
          }}
        ></SchedualeDemoPopup>
      )}
    </>
  );
};

export default FreeTrialContent;
